import { PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN } from "helpers/sf_constants";

import { GET_CUSTOMIZE_COLUMNS_ORDER, GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS, GET_CUSTOMIZE_COLUMNS_ORDER_ERROR, UPDATE_CUSTOMIZE_COLUMNS_ORDER, UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS, UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR } from "./actionTypes"

const INIT_STATE = {
    leads_customize_columns_order: [],
    leads_customize_columns_order_loading: false,
    leads_customize_columns_order_error: null,
    calls_customize_columns_order: [],
    calls_customize_columns_order_loading: false,
    calls_customize_columns_order_error: null,
    prospects_customize_columns_order: [],
    prospects_customize_columns_order_loading: false,
    prospects_customize_columns_order_error: null,
    campaigns_customize_columns_order: [],
    campaigns_customize_columns_order_loading: false,
    campaigns_customize_columns_order_error: null,
    clicks_dashboard_customize_columns_order: [],
    clicks_dashboard_customize_columns_order_loading: false,
    clicks_dashboard_customize_columns_order_error: null,
    leads_dashboard_customize_columns_order: [],
    leads_dashboard_customize_columns_order_loading: false,
    leads_dashboard_customize_columns_order_error: null,
    calls_dashboard_for_states_customize_columns_order: [],
    calls_dashboard_for_states_customize_columns_order_loading: false,
    calls_dashboard_for_states_customize_columns_order_error: null,
    calls_dashboard_for_campaigns_customize_columns_order: [],
    calls_dashboard_for_campaigns_customize_columns_order_loading: false,
    calls_dashboard_for_campaigns_customize_columns_order_error: null,
}

const CustomizeColumnsOrder = (state = INIT_STATE, action) => {
    const page_name = action?.payload?.page_name;
    switch (page_name) {
        case PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.LEADS:
            return LeadsCustomizeColumnsOrder(state, action);
        case PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CALLS:
            return CallsCustomizeColumnsOrder(state, action);
        case PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.PROSPECTS:
            return ProspectCustomizeColumnsOrder(state, action);
        case PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CAMPAIGNS:
            return CampaignsCustomizeColumnsOrder(state, action);
        case PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CLICKS_DASHBOARD:
            return ClickDashboardCustomizeColumnsOrder(state, action);
        case PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.LEADS_DASHBOARD:
            return LeadDashboardCustomizeColumnsOrder(state, action);
        case PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CALLS_DASHBOARD_FOR_STATES:
            return CallsDashboardCustomizeColumnsOrderForStates(state, action);
        case PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CALLS_DASHBOARD_FOR_STATES:
            return CallsDashboardCustomizeColumnsOrderForCampaigns(state, action);
        default:
            return state;
    }
}

const LeadsCustomizeColumnsOrder = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                leads_customize_columns_order_loading: true,
                leads_customize_columns_order_error: null,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                leads_customize_columns_order: action?.payload?.column_order,
                leads_customize_columns_order_loading: false,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                leads_customize_columns_order_error: action.payload,
                leads_customize_columns_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                leads_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                leads_customize_columns_order: action?.payload?.column_order,
                leads_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                leads_customize_columns_order_error: action.payload,
                leads_customize_columns_order_loading: false
            }

        default:
            return state
    }

}
const CallsCustomizeColumnsOrder = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                calls_customize_columns_order_loading: true,
                calls_customize_columns_order_error: null,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                calls_customize_columns_order: action?.payload?.column_order,
                calls_customize_columns_order_loading: false,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                calls_customize_columns_order_error: action.payload,
                calls_customize_columns_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                calls_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                calls_customize_columns_order: action?.payload?.column_order,
                calls_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                calls_customize_columns_order_error: action.payload,
                calls_customize_columns_order_loading: false
            }

        default:
            return state
    }

}

const ProspectCustomizeColumnsOrder = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                prospects_customize_columns_order_loading: true,
                prospects_customize_columns_order_error: null,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                prospects_customize_columns_order: action?.payload?.column_order,
                prospects_customize_columns_order_loading: false,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                prospects_customize_columns_order_error: action.payload,
                prospects_customize_columns_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                prospects_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                prospects_customize_columns_order: action?.payload?.column_order,
                prospects_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                prospects_customize_columns_order_error: action.payload,
                prospects_customize_columns_order_loading: false
            }

        default:
            return state
    }

}

const CampaignsCustomizeColumnsOrder = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                campaigns_customize_columns_order_loading: true,
                campaigns_customize_columns_order_error: null,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                campaigns_customize_columns_order: action?.payload?.column_order,
                campaigns_customize_columns_order_loading: false,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                campaigns_customize_columns_order_error: action.payload,
                campaigns_customize_columns_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                campaigns_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                campaigns_customize_columns_order: action?.payload?.column_order,
                campaigns_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                campaigns_customize_columns_order_error: action.payload,
                campaigns_customize_columns_order_loading: false
            }

        default:
            return state
    }

}
const ClickDashboardCustomizeColumnsOrder = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                clicks_dashboard_customize_columns_order_loading: true,
                clicks_dashboard_customize_columns_order_error: null,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                clicks_dashboard_customize_columns_order: action?.payload?.column_order,
                clicks_dashboard_customize_columns_order_loading: false,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                clicks_dashboard_customize_columns_order_error: action.payload,
                clicks_dashboard_customize_columns_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                clicks_dashboard_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                clicks_dashboard_customize_columns_order: action?.payload?.column_order,
                clicks_dashboard_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                clicks_dashboard_customize_columns_order_error: action.payload,
                clicks_dashboard_customize_columns_order_loading: false
            }

        default:
            return state
    }

}
const LeadDashboardCustomizeColumnsOrder = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                leads_dashboard_customize_columns_order_loading: true,
                leads_dashboard_customize_columns_order_error: null,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                leads_dashboard_customize_columns_order: action?.payload?.column_order,
                leads_dashboard_customize_columns_order_loading: false,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                leads_dashboard_customize_columns_order_error: action.payload,
                leads_dashboard_customize_columns_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                leads_dashboard_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                leads_dashboard_customize_columns_order: action?.payload?.column_order,
                leads_dashboard_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                leads_dashboard_customize_columns_order_error: action.payload,
                leads_dashboard_customize_columns_order_loading: false
            }

        default:
            return state
    }

}
const CallsDashboardCustomizeColumnsOrderForStates = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                calls_dashboard_for_states_customize_columns_order_loading: true,
                calls_dashboard_for_states_customize_columns_order_error: null,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                calls_dashboard_for_states_customize_columns_order: action?.payload?.column_order,
                calls_dashboard_for_states_customize_columns_order_loading: false,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                calls_dashboard_for_states_customize_columns_order_error: action.payload,
                calls_dashboard_for_states_customize_columns_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                calls_dashboard_for_states_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                calls_dashboard_for_states_customize_columns_order: action?.payload?.column_order,
                calls_dashboard_for_states_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                calls_dashboard_for_states_customize_columns_order_error: action.payload,
                calls_dashboard_for_states_customize_columns_order_loading: false
            }

        default:
            return state
    }

}
const CallsDashboardCustomizeColumnsOrderForCampaigns = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                calls_dashboard_for_campaigns_customize_columns_order_loading: true,
                calls_dashboard_for_campaigns_customize_columns_order_error: null,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                calls_dashboard_for_campaigns_customize_columns_order: action?.payload?.column_order,
                calls_dashboard_for_campaigns_customize_columns_order_loading: false,
            }
        case GET_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                calls_dashboard_for_campaigns_customize_columns_order_error: action.payload,
                calls_dashboard_for_campaigns_customize_columns_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER:
            return {
                ...state,
                calls_dashboard_for_campaigns_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
            return {
                ...state,
                calls_dashboard_for_campaigns_customize_columns_order: action?.payload?.column_order,
                calls_dashboard_for_campaigns_customize_columns_order_loading: false
            }
        case UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR:
            return {
                ...state,
                calls_dashboard_for_campaigns_customize_columns_order_error: action.payload,
                calls_dashboard_for_campaigns_customize_columns_order_loading: false
            }

        default:
            return state
    }

}
export default CustomizeColumnsOrder;
